/* tslint:disable:indent */
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {SubSubGroup} from '../../model/sub-sub-group';
import {SubSubSubGroup} from '../../model/sub-sub-sub-group';
import {Field} from '../../model/field';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {EformDataService} from '../../services/eform-data.service';
import {EformConditionsService} from '../../services/eform-conditions.service';
import {EformElementsService} from '../../services/efom-elements.service';
import { EformDuplicableEntityService } from '../../services/eform-duplicable-entity.service';
import { ChangeDetectorRef } from '@angular/core';
import { DuplicableElementsInputIdEnum } from '../../enum/duplicable-elements-input-id.enum';
import {EformAccordionService} from '../../services/eform-accordion.service';


@Component({
  selector: 'app-sub-sub-group',
  templateUrl: './sub-sub-group.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class SubSubGroupComponent implements OnInit, AfterViewInit {

  @Input() subSubGroup: SubSubGroup = {} as SubSubGroup;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() noticeValue: any = {};
  @Output() newSubSubGroup = new EventEmitter();
  @Output() deleteSubSubGroup = new EventEmitter();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() subSectionId: string;
  @Input() indexGrp: string = '';
  @Input() parentsChild: any;
  @Input() linkForRouter: string;
  @Input() index: string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;
  repeatablePathForElementDuplicable: string;



  constructor(private stepperBuilderService: StepperBuilderService,
    private eformDuplicableEntityService: EformDuplicableEntityService, private eformsSubjectService: EformsSubjectService, private eformDataService: EformDataService, private eformConditionService: EformConditionsService, private eformElementsService: EformElementsService, private changeDetectorRef: ChangeDetectorRef,
    private eformAccordionService: EformAccordionService) {
  }

  ngOnInit(): void {
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();
  }

  ngAfterViewInit() {
    //Dans le cas de l'edition, on cherche les elements répétable à initialiser
    // 🔧 FIX 2026-02-11: Ne pas créer automatiquement des éléments pour les sub-sub-groups nouvellement ajoutés manuellement
    const isManuallyAdded = this.subSubGroup?.id?.includes('_') && !this.subSubGroup?.id?.endsWith('_0');

    let elementToCreate = this.eformConditionService.findElementsToCreate(this.subSubGroup, this.repeatablePathWithIndex, this.noticeValue);

    if (elementToCreate?.length && !isManuallyAdded) {
      elementToCreate.forEach(e => {
        this.addSubSubGroup();
      });
    }
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSubGroup.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.subSubGroup.fields.filter(el => el.id.startsWith($event.id)).length
    this.subSubGroup.fields.splice((this.subSubGroup.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);

    this.repeatablePath = field.jsonPath + '_SEPSEP_' + (elementNumber);
    // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici

  }

  deleteField($event: any) {
    this.subSubGroup.fields = this.subSubGroup.fields.filter(obj => obj !== $event);
    let deletedFieldIndex = +$event.id.split('_')[1];
    //On decale tous supérieurs à celui supprimé les id de 1 pour rester syncro avec les controls
    this.subSubGroup.fields.filter(f => f.id.includes('_')).forEach(f => {
      let splittedId = f.id.split('_');
      let actualIndex = +splittedId[1];
      if (actualIndex > deletedFieldIndex) {
        let newIndex = actualIndex - 1;
        f.id = splittedId[0] + '_' + newIndex;
      }
    });
  }

  addSubSubGroup() {
    this.newSubSubGroup.emit(this.subSubGroup);
  }

  removeSubSubGroup() {
    this.deleteSubSubGroup.emit(this.subSubGroup);
  }

  newSubSubSubGroup($event: any) {
    const subSubSubGroup: SubSubSubGroup = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSubGroup.subSubSubGroup.map(gr => gr.id);
    subSubSubGroup.subSubSubSubGroup = this.eformElementsService.clearRepeatedGroups(subSubSubGroup.subSubSubSubGroup);

    //Suppression temporaire du point de contact spécifique dans les subSubSubSubGroup
    if(subSubSubGroup?.subSubSubSubGroup){
      subSubSubGroup.subSubSubSubGroup = subSubSubGroup.subSubSubSubGroup.filter(g=>g.id !='GR-Touch-Point');
    }

    let elementNumber = 1;
    if (subSubSubGroup.id.includes("_")) {
      subSubSubGroup.repeatedId = subSubSubGroup.id.split('_').slice(1).map(Number);
      subSubSubGroup.id = subSubSubGroup.id.split('_').slice(0, -1).join('_');
    } else {
      subSubSubGroup.repeatedId = [0];
    }
    while (ids.includes(subSubSubGroup.id + '_' + elementNumber)) {
      elementNumber++;
    }

    subSubSubGroup.id = subSubSubGroup.id.split('_')[0];
    subSubSubGroup.repeatedId.splice(-1, 1, elementNumber);
    subSubSubGroup.repeatedId.forEach(id => subSubSubGroup.id += '_' + id);

    subSubSubGroup.subSubSubSubGroup = this.eformElementsService.updateIdsRecursively(subSubSubGroup.subSubSubSubGroup, [...subSubSubGroup.repeatedId]);

    this.subSubGroup.subSubSubGroup.push(subSubSubGroup);
    this.repeatablePath = subSubSubGroup.jsonPath + '_SEPSEP_' + (elementNumber);
    this.isDeletable(subSubSubGroup.id);

    if (!this.isInsideDuplicableSection(subSubSubGroup.id)) {
      this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);
    }
  }

  /**
   * Vérifie si le groupe est à l'intérieur d'une section duplicable
   */
  private isInsideDuplicableSection(id: string): boolean {
    const isInEnum = this.subSectionId && Object.values(DuplicableElementsInputIdEnum).includes(this.subSectionId as any);

    return isInEnum || false;
  }

  deleteSubSubSubGroup($event: any) {
    // 🔧 FIX 2026-02-16: On récupère l'index AVANT de modifier la liste
    let indexToDelete = 0;
    if ($event.repeatedId) {
      indexToDelete = $event.repeatedId.slice(-1)[0];
    } else {
      indexToDelete = 0;
    }

    // 🔧 FIX 2026-02-16: Calculer le repeatablePathWithIndex avec l'index explicite AVANT les modifications
    const repeatablePathForDelete = this.getRepeatablePathWithIndexForSubSubSubGroupWithExplicitIndex($event, indexToDelete);

    this.subSubGroup.subSubSubGroup = this.subSubGroup.subSubSubGroup.filter(obj => obj !== $event);

    this.subSubGroup.subSubSubGroup.filter(subSubSubGroup => subSubSubGroup.id.includes($event.id.split("_")[0])).forEach(subSubSubGroup => {
      if (subSubSubGroup.repeatedId && subSubSubGroup.repeatedId.slice(-1)[0] > indexToDelete) {
        subSubSubGroup.repeatedId.push(subSubSubGroup.repeatedId.pop() - 1);
        subSubSubGroup.id = subSubSubGroup.id.split("_")[0];
        subSubSubGroup.repeatedId.forEach(id => subSubSubGroup.id += '_' + id);
        subSubSubGroup.subSubSubSubGroup = this.eformElementsService.updateIdsRecursively(subSubSubGroup.subSubSubSubGroup, [...subSubSubGroup.repeatedId]);
      }
      if (!$event.id.includes("_") && subSubSubGroup.repeatedId.slice(-1)[0] === 0) {
        subSubSubGroup.id = subSubSubGroup.id.slice(0, -2);
      }
    });

    //On supprime le groupe du formulaire avec l'index explicite
    let pathElements: Array<string> = $event.jsonPath.split('.');
    pathElements.pop();
    if(pathElements[pathElements.length-1]==='strategicprocurementstatistics[]'){
      pathElements.pop();
    }
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, repeatablePathForDelete, indexToDelete, $event.listname);
    this.isDeletable($event.id);

    if (!this.isInsideDuplicableSection($event.id)) {
      this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);
    }
  }

  /**
   * 🔧 FIX 2026-02-16: Nouvelle méthode pour calculer le repeatablePathWithIndex avec un index explicite
   */
  private getRepeatablePathWithIndexForSubSubSubGroupWithExplicitIndex = (subSubSubGroup, explicitIndex: number): string => {
    if (subSubSubGroup.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      return pathToReturn + subSubSubGroup.jsonPath + '_INDEX_' + explicitIndex;
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else if (field.isJsonPathAlreadyUsed && !field.conditions) {
      let tempJsonPath;
      if (this.repeatablePathWithIndex) {
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]'))
      } else {
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.indexOf('[]'))
      }
      let pathElements = tempJsonPath.split('.');
      let tempControl = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
      let index = 0;
      if (Array.isArray(tempControl?.controls)) {
        index = tempControl.controls.length;
      }
      return tempJsonPath + '[]' + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathForDuplicableElement = (): string =>{
    return this.repeatablePathForElementDuplicable
  }

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      return tempJsonPath + '_INDEX_' + (this.eformDataService.getArray(field, this.formGroup, this.repeatablePathWithIndex, tempJsonPath)) + '_SEPSEP_';
    } else if (field.isJsonPathAlreadyUsed) {
      let tempJsonPath;
      let tmpPath;
      if (this.repeatablePathWithIndex) {
        tmpPath = field?.jsonPath?.replace(this.repeatablePathWithIndex.slice(0, this.repeatablePathWithIndex.indexOf('val')), '');
        let tmpPathArray: any[] = tmpPath.split('.');
        if (tmpPathArray.filter(e => e.includes('[]')).length > 1) {
          tmpPathArray.shift()
          tmpPath = tmpPathArray.join('.');
        }
        if (tmpPath.includes('fieldsprivacy')) {
          tmpPath = tmpPath?.slice(tmpPath.indexOf('fieldsprivacy'), tmpPath?.indexOf('val'));
        }
        tmpPath = tmpPath?.slice(0, tmpPath?.indexOf('[]'));
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.indexOf(tmpPath) + tmpPath.length);
      } else {
        tempJsonPath = field?.jsonPath?.slice(0, field?.jsonPath?.indexOf('[]'))
      }
      let pathElements = tempJsonPath.split('.');
      let tempControl = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
      let index = 0;
      if (Array.isArray(tempControl?.controls)) {
        let count = 0;
        const pathToCheck = field?.jsonPath?.replaceAll('[]', '').split('.').slice(field?.jsonPath?.replaceAll('[]', '').split('.').indexOf(pathElements[pathElements.length - 1]) + 1, field?.jsonPath?.replaceAll('[]', '').split('.').indexOf('val'));
        if (pathToCheck.length > 1) {
          let i = 0;
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[i]) && !Array.isArray(element.get(pathToCheck[i])?.controls)) {
              if (this.checkPathrecursively(element.get(pathToCheck[i]), pathToCheck, i + 1, pathToCheck[pathToCheck.length - 1])) {
                count++
              }
            }
          }
        } else {
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[0])) {
              count++
            }
          }
        }

        index = count;
      }
      return tempJsonPath + '[]' + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return '';
    }
  }

  checkPathrecursively(tmpElement, elements, index, lastElement): boolean {
    let isFound = false;
    if (Array.isArray(tmpElement?.controls)) {
      return false;
    } else {
      if (tmpElement?.controls[elements[index]]) {
        if (elements[index] != lastElement) {
          this.checkPathrecursively(tmpElement?.controls[elements[index]], elements, index + 1, lastElement)
        } else {
          return true;
        }
      }
    }
    return isFound;
  }

  getRepeatablePathWithIndexForSubSubSubGroup(subSubSubGroup, isForDelete?) {
    if (subSubSubGroup.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      let index = this.eformDataService.getArray(subSubSubGroup, this.formGroup, this.repeatablePathWithIndex, undefined, undefined, undefined, undefined, undefined, isForDelete);
      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, subSubSubGroup.jsonPath, Number(index), undefined,isForDelete)
      return pathToReturn + subSubSubGroup.jsonPath + '_INDEX_' + (index);
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getIndex(id: string) {
    let element = id.split("_");
    return {value: id.split("_")[element.length - 1], bool: element.length > 1};
  }

  private isDeletable(elementId) {
    let baseId = elementId;
    if (elementId.includes('_')) {
      baseId = elementId.split('_')[0];
    }
    let filteredElements = this.subSubGroup.subSubSubGroup.filter(el => el.id === baseId || el.id.startsWith(baseId + '_'));
    // Update deletable status and trigger change detection
    filteredElements.forEach(s => s.deletable = filteredElements.length > 1);
    this.changeDetectorRef.detectChanges();
  }

  parcoursUtilisateur(subSubGroup){
    return subSubGroup.parcoursUtilisateur?.messageInfo;
  }

  /**
   * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   */
  getGroupType(elementId: string): string {
    return this.eformAccordionService.extractGroupType(elementId);
  }
}
